// Booking pop-ups (spec D7, unchanged behaviour): the openers show the lawyer selection
// pop-up, each lawyer button swaps it for that lawyer's calendar pop-up, and a click on a
// pop-up's overlay or its close button hides it. The markup hooks are data attributes, so
// no inline handler is left in the pages (needed for the CSP).

const SELECTION_ID = "rdvModal";
// The calendar pop-up of each lawyer, by the value of the button's data-rdv-avocat.
const CALENDAR_IDS = { emilie: "rdvModalEmilie", marieta: "rdvModalMarieta" };

const SELECTORS = {
  // data-rdv-open: the "Planifier un RDV" / "Prendre RDV" buttons and the calendar contact block.
  open: "[data-rdv-open]",
  // data-rdv-avocat="emilie" | "marieta": the two buttons of the selection pop-up.
  lawyer: "[data-rdv-avocat]",
  // The × of the selection pop-up.
  close: ".close-modal",
};

function setDisplay(id, display) {
  const modal = document.getElementById(id);
  if (modal) modal.style.display = display;
}

export function initModals() {
  for (const opener of document.querySelectorAll(SELECTORS.open)) {
    opener.addEventListener("click", (event) => {
      // The header opener is <a href="#">: neither the URL nor the scroll position moves.
      event.preventDefault();
      setDisplay(SELECTION_ID, "flex");
    });
  }
  for (const button of document.querySelectorAll(SELECTORS.lawyer)) {
    const calendar = CALENDAR_IDS[button.dataset.rdvAvocat];
    button.addEventListener("click", () => {
      setDisplay(SELECTION_ID, "none");
      if (calendar) setDisplay(calendar, "flex");
    });
  }
  for (const id of [SELECTION_ID, ...Object.values(CALENDAR_IDS)]) {
    const modal = document.getElementById(id);
    // A click on the overlay itself (not on its content) or on a close button.
    modal?.addEventListener("click", (event) => {
      if (event.target === modal || event.target.matches(SELECTORS.close)) {
        modal.style.display = "none";
      }
    });
  }
}
